/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { SolrProxy } from '../models/solr-proxy';
@Injectable({
  providedIn: 'root',
})
class ProxyService extends __BaseService {
  static readonly proxyCreatePath = '/proxy/';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param data undefined
   */
  proxyCreateResponse(data: SolrProxy): __Observable<__StrictHttpResponse<SolrProxy>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/proxy/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SolrProxy>;
      })
    );
  }
  /**
   * @param data undefined
   */
  proxyCreate(data: SolrProxy): __Observable<SolrProxy> {
    return this.proxyCreateResponse(data).pipe(
      __map(_r => _r.body as SolrProxy)
    );
  }
}

module ProxyService {
}

export { ProxyService }
